export class Toets {
  constructor(public id: string  ,public name : string , public groep : string) { }
}